/**
 * External Dependencies
 */
import 'jquery';

$(document).ready(() => {
  const flipbookPDF = $('#flipbook').data('flipbook');

  if (flipbookPDF) {
    $('#flipbook').wowBook({
      container: true,
      containerWidth: '100%',
      pageNumbers: true,
      pdf: flipbookPDF,
      pdfFind: true,
      pdfTextSelectable: true,
      centeredWhenClosed: true,
      hardcovers: true,
      curl: false,
      toolbar: "lastLeft, left, currentPage, right, lastRight, find, toc, zoomin, zoomout, download, flipsound, fullscreen, thumbnails",
      thumbnailsPosition: 'bottom',
      responsiveSinglePage: true,
      responsiveHandleWidth: 50,
    });
  }
});
